// ThemeContext.js

import React, { useState, useEffect, createContext } from "react";

const defaultState = {
  isDarkMode: false,
  toggleDark: () => {},
};

const ThemeContext = createContext(defaultState);

const supportsDarkMode = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches === true;

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const theme = localStorage.getItem("theme");
    return theme === "dark" || (theme !== "light" && supportsDarkMode());
  });

  useEffect(() => {
    const mode = isDarkMode ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem("theme", mode);
  }, [isDarkMode]);

  const toggleDark = () => {
    setIsDarkMode((prevDark) => !prevDark);
  };

  return (
    <ThemeContext.Provider
      value={{
        isDarkMode,
        toggleDark,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
